import { every } from 'lodash'

export const onlyNumbersAllowed = (value: string) => {
  const list = value.split('')
  const isAllNumbers = every(list, character => !isNaN(parseInt(character, 10)))

  return isAllNumbers || value === ''
}
